import React from 'react';
import { Box } from '@mui/material';
import { CustomTooltip } from './tooltip_component';
import inventoryLeftBarIcon from '../../Assets/AlertIcon/inventoryLeftBar.svg';

export const InventoryLeftBarPath = (props) => {
  const { selectedIcon, activeItemStyle, iconStyle, handleIconClick, hideTooltip = false } = props;

  const iconContent = (
    <Box
      style={selectedIcon === 5 ? activeItemStyle : iconStyle}
      onClick={() => handleIconClick(5, 'Inventory Management')}
    >
      <img src={inventoryLeftBarIcon} alt="Inventory" width="20" height="20" />
    </Box>
  );

  return (
    <>
      {hideTooltip ? (
        iconContent
      ) : (
        <CustomTooltip title="Inventory Management">{iconContent}</CustomTooltip>
      )}
    </>
  );
};
